import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MyDashboard from "../pages/MyDashboard";
import LeadSearch from "../pages/LeadSearch";
import Login from "../pages/Login";
import LeadDetails from "../pages/LeadDetails";
import { AuthContext } from "../context/AuthContext";

const CheckToken = ({ type }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    }
  }, [isAuthenticated, navigate]);

  if (type === "lead" && isAuthenticated) {
    return <LeadSearch tab="3" />;
  } else if (type === "dashboard" && isAuthenticated) {
    return <MyDashboard />;
  } else if (type === "leaddetails" && isAuthenticated) {
    return <LeadDetails />;
  } else {
    return <Login />;
  }
};

export default CheckToken;
